import React, { useEffect } from "react";

const News = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="xl:min-h-[calc(100vh-100px)] xs:min-h-[calc(100vh-265px)] h-auto">
      <div className="xs:pt-12 lg:pt-[200px] flex justify-center items-center flex-col xs:gap-8 md:gap-10 xl:gap-14">
        <h2 className="xs:text-[15px] md:text-[20px] xl:text-[25px] font-bold font-roboto underline underline-offset-[12px] uppercase decoration-bbf-green  text-start">
          Neuigkeiten
        </h2>
            <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>04.03.26</div>
          <div className="font-bold">Caravaning & DAHON: Mehr Freiheit im Handumdrehen</div>
          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
           Aus dem Mein Hobby Magazin: ein DAHON-Faltrad als kompakter Begleiter für unterwegs. Wir zeigen, warum Falträder gerade beim Caravaning so praktisch sind und worauf man bei Auswahl und Ausstattung achten sollte.
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://media.bbf-bike.de/shop/documents/bbf-bike/Faltrad_MeinHobby_Fru%CC%88hjahr2026.pdf">
                Hier geht’s zum Artikel
              </a>
            </div>
            <img
              src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/faltrad_meinHobby_dahon.jpg"
              alt="Dahon"
              className="object-cover h-96 w-[45%] xs:h-[250px]"
            />
          </div>
        </div>

        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>12.12.25</div>
          <div className="font-bold">
            🚴‍♂️ Preis-Leistungssieger bei Radfahren.de! – Dahon Mariner i7U
            überzeugt auf ganzer Linie 🏆
          </div>
          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
                Das Dahon Mariner i7U wurde im großen Faltrad-Test 2026 des
                Magazins Radfahren.de zum Preis-Leistungssieger gekürt – mit
                einer hervorragenden Gesamtnote von 1,7
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://media.bbf-bike.de/shop/documents/bbf-bike/dahon_mariner_preis_leistungstestsieger.pdf">
                Zum Preis-Leistungssieger
              </a>
            </div>
            <img
              src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/dahon_mariner_preis_leistungstestsieger.jpg"
              alt="Dahon"
              className="object-cover h-96 w-[45%] xs:h-[250px]"
            />
          </div>
        </div>

        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>23.09.25</div>
          <div className="font-bold">Dahon geht an die Börse</div>
          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
                Am 9. September 2025 wurde Dahon offiziell an der Hongkonger
                Börse gelistet. Als exklusiver Vertriebspartner von Dahon in
                Deutschland freut sich die BBF GmbH über diesen wichtigen
                Meilenstein. Gemeinsam mit Dahon bringen wir innovative
                Falträder auf die Straße und stärken die Zukunft des urbanen
                Radfahrens.
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://www.velobiz.de/news/faltradhersteller-dahon-rollt-an-die-boerse-veloQXJ0aWNsZS8zMzQ4MQbiz">
                Hier geht’s zum Artikel
              </a>
            </div>
            <img
              src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/dahon_news.jpg"
              alt="Dahon"
              className="object-cover h-96 w-[45%] xs:h-[250px]"
            />
          </div>
        </div>

        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>16.06.25</div>
          <div className="font-bold">
            Ein Stück Berlin für den Alltag – Hauptstadtrad jetzt bundesweit
            beim Fachhandel
          </div>
          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
                Nach dem erfolgreichen Aufbau eines Fachhändlernetzwerks in
                Berlin mit inzwischen über 20 Partnern hat die HAUPTSTADTRAD nun
                den nächsten Schritt gemacht: Der Relaunch bringt neue Modelle –
                und öffnet gleichzeitig den Zugang für Fachhändler im gesamten
                Bundesgebiet.
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://media.bbf-bike.de/shop/documents/bbf-bike/hauptstadtrad.pdf">
                Zur Pressemeldung
              </a>
            </div>

            <img
              src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/hauptstadtrad.jpg"
              alt="cycle_parts"
              className="object-cover h-96 w-[45%] xs:h-[250px]"
            />
          </div>
        </div>
        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>10.06.25</div>
          <div className="font-bold">
            Neuer Teilekatalog 2025 jetzt verfügbar
          </div>

          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
                Die BBF-Eigenmarke CP CycleParts feiert den 400. Artikel mit
                neuen Komponenten und einem Jubiläumsgriff.
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://media.bbf-bike.de/shop/documents/bbf-bike/BBF_Teile_Gesamtkatalog_2025-2026.pdf">
                BBF Teile Gesamtkatalog 2025-2026
              </a>
            </div>

            <a
              href="https://media.bbf-bike.de/shop/documents/bbf-bike/BBF_Teile_Gesamtkatalog_2025-2026.pdf"
              target="_blank"
              className="w-full">
              <img
                src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/BBF%20BIKE_Teilekatalog_2025_26.jpg"
                alt="cycle_parts"
                className="object-contain h-[400px] w-[45%]"
              />
            </a>
          </div>

          {/* <a href='https://media.bbf-bike.de/shop/documents/bbf-bike/BBF_Teile_Gesamtkatalog_2025-2026.pdf' target='_blank' className='w-full'>
                                    <img src='https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/BBF%20BIKE_Teilekatalog_2025_26.jpg' alt='cycle_parts' className='object-contain h-[400px] w-[300px]'/>
            </a>

            <div className='text-left'>Entdecken Sie unser aktuelles Sortiment an Komponenten und Zubehör – der neue BBF Teilekatalog steht ab sofort zum Download bereit.</div>
            <a className='p-3 text-bbf-white bg-bbf-green cursor-pointer' target='_blank' href='https://media.bbf-bike.de/shop/documents/bbf-bike/BBF_Teile_Gesamtkatalog_2025-2026.pdf'>BBF Teile Gesamtkatalog 2025-2026</a> */}
        </div>

        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>04.06.25</div>
          <div className="font-bold">
            CP CycleParts knackt 400 Produkte – Jubiläumsgriff vorgestellt
          </div>
          <div className="flex justify-start items-start gap-12 w-full">
            <div className="flex justify-start items-start flex-col gap-12 w-[55%] pt-16 xs:pt-4">
              <div className="text-left">
                Die BBF-Eigenmarke CP CycleParts feiert den 400. Artikel mit
                neuen Komponenten und einem Jubiläumsgriff.
              </div>
              <a
                className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
                target="_blank"
                href="https://media.bbf-bike.de/shop/documents/bbf-bike/PMCP_CycleParts_feiert_400.pdf">
                Zur Pressemeldung
              </a>
            </div>

            <img
              src="https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/CPCycleParts_Flasche.jpg"
              alt="cycle_parts"
              className="object-cover h-96 w-[45%] xs:h-[250px]"
            />
          </div>
        </div>

        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center">
          <div>27.05.25</div>
          <div className="font-bold">
            Wir freuen uns, Ihnen unser neues Imagebook zu präsentieren!
          </div>
          <div className="text-left">
            Entdecken Sie unsere Markenwelt, Innovationen und die Leidenschaft
            fürs Fahrrad. Jetzt reinschauen und inspirieren lassen!
          </div>
          <a
            className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
            target="_blank"
            href="https://media.bbf-bike.de/shop/documents/bbf-bike/Imagebook_Desktop_Version_2025.pdf">
            Imagebook herunterladen
          </a>
        </div>
        <div className="xl:w-[55%] xs:w-[85%] flex justify-center  items-start flex-col gap-6 font-roboto xs:text-[13px] md:text-[17px] text-center pb-16">
          <div>15.05.25</div>
          <div className="font-bold">
            Dahon überzeugt im ADAC-Faltrad-Test 2025
          </div>
          <div className="text-left">
            Im aktuellen ADAC-Test für Klapp- und Falträder punktet Dahon mit
            Qualität, Komfort und Fahrverhalten. Ein starkes Ergebnis für alle,
            die auf zuverlässige Mobilität setzen.
          </div>
          <a
            className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
            href="https://www.adac.de/rund-ums-fahrzeug/zweirad/fahrrad-ebike-pedelec/tests/klapprad-faltrad-test/"
            target="_blank">
            Hier geht’s zum Testbericht
          </a>
          <a
            className="p-3 text-bbf-white bg-bbf-green cursor-pointer"
            target="_blank"
            href="https://media.bbf-bike.de/shop/documents/bbf-bike/Grafik_Klappr%C3%A4der_im_Test.pdf">
            ÖAMTC Test-Ergebnis herunterladen
          </a>
        </div>
      </div>
    </div>
  );
};

export default News;
